var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-chart",style:({ background : _vm.chartColor || '#e3e3e3' })},[_c('CardLineChart',{attrs:{"metricTimeseries":_vm.metricTimeseries,"animationDuration":0,"styles":{
                     height: '190px',
                     padding: '1rem',
                     position: 'relative'
               }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }